<template>
    <footer>
        <div class="block social">
            <a href="https://uni-dubna.ru" class="home-link">
                <img src="../../src/assets/logoSmall.png">
            </a>
            <div class="social-links">
                <div class="t-sociallinks__item"><a href="https://www.facebook.com/unidubnanews/" target="_blank">
                    <svg class="t-sociallinks__svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px"
                         viewBox="0 0 48 48" enable-background="new 0 0 48 48" xml:space="preserve"><desc>Facebook</desc>
                        <path style="fill:#525252;"
                              d="M47.761,24c0,13.121-10.638,23.76-23.758,23.76C10.877,47.76,0.239,37.121,0.239,24c0-13.124,10.638-23.76,23.764-23.76C37.123,0.24,47.761,10.876,47.761,24 M20.033,38.85H26.2V24.01h4.163l0.539-5.242H26.2v-3.083c0-1.156,0.769-1.427,1.308-1.427h3.318V9.168L26.258,9.15c-5.072,0-6.225,3.796-6.225,6.224v3.394H17.1v5.242h2.933V38.85z"></path></svg>
                </a></div>
                <div class="t-sociallinks__item"><a href="https://vk.com/unidubna_official" target="_blank">
                    <svg class="t-sociallinks__svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px"
                         viewBox="0 0 48 48" enable-background="new 0 0 48 48" xml:space="preserve"><desc>VK</desc>
                        <path style="fill:#525252;"
                              d="M47.761,24c0,13.121-10.639,23.76-23.76,23.76C10.878,47.76,0.239,37.121,0.239,24c0-13.123,10.639-23.76,23.762-23.76C37.122,0.24,47.761,10.877,47.761,24 M35.259,28.999c-2.621-2.433-2.271-2.041,0.89-6.25c1.923-2.562,2.696-4.126,2.45-4.796c-0.227-0.639-1.64-0.469-1.64-0.469l-4.71,0.029c0,0-0.351-0.048-0.609,0.106c-0.249,0.151-0.414,0.505-0.414,0.505s-0.742,1.982-1.734,3.669c-2.094,3.559-2.935,3.747-3.277,3.524c-0.796-0.516-0.597-2.068-0.597-3.171c0-3.449,0.522-4.887-1.02-5.259c-0.511-0.124-0.887-0.205-2.195-0.219c-1.678-0.016-3.101,0.007-3.904,0.398c-0.536,0.263-0.949,0.847-0.697,0.88c0.31,0.041,1.016,0.192,1.388,0.699c0.484,0.656,0.464,2.131,0.464,2.131s0.282,4.056-0.646,4.561c-0.632,0.347-1.503-0.36-3.37-3.588c-0.958-1.652-1.68-3.481-1.68-3.481s-0.14-0.344-0.392-0.527c-0.299-0.222-0.722-0.298-0.722-0.298l-4.469,0.018c0,0-0.674-0.003-0.919,0.289c-0.219,0.259-0.018,0.752-0.018,0.752s3.499,8.104,7.573,12.23c3.638,3.784,7.764,3.36,7.764,3.36h1.867c0,0,0.566,0.113,0.854-0.189c0.265-0.288,0.256-0.646,0.256-0.646s-0.034-2.512,1.129-2.883c1.15-0.36,2.624,2.429,4.188,3.497c1.182,0.812,2.079,0.633,2.079,0.633l4.181-0.056c0,0,2.186-0.136,1.149-1.858C38.281,32.451,37.763,31.321,35.259,28.999"></path></svg>
                </a></div>
                <div class="t-sociallinks__item"><a href="https://www.youtube.com/channel/UCiSSFkaymoBQecGADO5icbA/"
                                                    target="_blank">
                    <svg class="t-sociallinks__svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px"
                         viewBox="0 0 48 48" enable-background="new 0 0 48 48" xml:space="preserve"><desc>Youtube</desc>
                        <path style="fill:#525252;"
                              d="M24 0.0130005C37.248 0.0130005 47.987 10.753 47.987 24C47.987 37.247 37.247 47.987 24 47.987C10.753 47.987 0.0130005 37.247 0.0130005 24C0.0130005 10.753 10.752 0.0130005 24 0.0130005ZM35.815 18.093C35.565 16.756 34.452 15.758 33.173 15.635C30.119 15.439 27.054 15.28 23.995 15.278C20.936 15.276 17.882 15.432 14.828 15.625C13.544 15.749 12.431 16.742 12.182 18.084C11.898 20.017 11.756 21.969 11.756 23.92C11.756 25.871 11.898 27.823 12.182 29.756C12.431 31.098 13.544 32.21 14.828 32.333C17.883 32.526 20.935 32.723 23.995 32.723C27.053 32.723 30.121 32.551 33.173 32.353C34.452 32.229 35.565 31.084 35.815 29.747C36.101 27.817 36.244 25.868 36.244 23.919C36.244 21.971 36.101 20.023 35.815 18.093ZM21.224 27.435V20.32L27.851 23.878L21.224 27.435Z"></path></svg>
                </a></div>
                <div class="t-sociallinks__item"><a href="https://www.instagram.com/unidubna_official/" target="_blank">
                    <svg class="t-sociallinks__svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" width="25px" height="25px" viewBox="0 0 30 30"
                         xml:space="preserve"><desc>Instagram</desc>
                        <path style="fill:#525252;"
                              d="M15,11.014 C12.801,11.014 11.015,12.797 11.015,15 C11.015,17.202 12.802,18.987 15,18.987 C17.199,18.987 18.987,17.202 18.987,15 C18.987,12.797 17.199,11.014 15,11.014 L15,11.014 Z M15,17.606 C13.556,17.606 12.393,16.439 12.393,15 C12.393,13.561 13.556,12.394 15,12.394 C16.429,12.394 17.607,13.561 17.607,15 C17.607,16.439 16.444,17.606 15,17.606 L15,17.606 Z"></path>
                        <path style="fill:#525252;"
                              d="M19.385,9.556 C18.872,9.556 18.465,9.964 18.465,10.477 C18.465,10.989 18.872,11.396 19.385,11.396 C19.898,11.396 20.306,10.989 20.306,10.477 C20.306,9.964 19.897,9.556 19.385,9.556 L19.385,9.556 Z"></path>
                        <path style="fill:#525252;"
                              d="M15.002,0.15 C6.798,0.15 0.149,6.797 0.149,15 C0.149,23.201 6.798,29.85 15.002,29.85 C23.201,29.85 29.852,23.202 29.852,15 C29.852,6.797 23.201,0.15 15.002,0.15 L15.002,0.15 Z M22.666,18.265 C22.666,20.688 20.687,22.666 18.25,22.666 L11.75,22.666 C9.312,22.666 7.333,20.687 7.333,18.28 L7.333,11.734 C7.333,9.312 9.311,7.334 11.75,7.334 L18.25,7.334 C20.688,7.334 22.666,9.312 22.666,11.734 L22.666,18.265 L22.666,18.265 Z"></path></svg>
                </a></div>
            </div>
            <div class="copy-right">© Университет "Дубна" 2020</div>
        </div>

        <div class="block">
            <div class="title">техническая поддержка</div>
            <div class="text">
                WhatsApp, Viber, Telegram,<br/>
                Google Duo, Hangouts<br/>
                <span class="msgtel">+7 (925) 443-19-21</span><br/>
                тел.: <a class="tel" href="tel:+7 (496) 216-60-63">+7 (496) 216-60-63</a><br/>
                <a class="email" href="mailto:oorkk@uni-dubna.ru">oorkk@uni-dubna.ru</a><br/>
                <a class="email" href="https://help.uni-dubna.ru">help.uni-dubna.ru</a>
            </div>

        </div>
        <div class="block">
            <div class="title">ЮРИДИЧЕСКАЯ ПОДДЕРЖКА</div>
            <div class="text">
                тел.: <a class="tel" href="tel:+7 (496) 216-60-09">+7 (496) 216-60-09</a><br/>
                <a class="email" href="mailto:LAW.unidubna@gmail.com">LAW.unidubna@gmail.com</a><br/>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "MainFooter"
    }
</script>

<style scoped>
    footer{
        background-color: black;
        height: 296px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .block{
        width: 260px;
        height: 221px;
        margin: 0 20px;
        text-align: left;
        font-family: 'PT Sans',Arial,sans-serif;
    }

    .block .title{
        color: #525252;
        letter-spacing: 1px;
        text-transform: uppercase;
        margin-bottom: 14px;
        font-size: 18px;
        line-height: 1.35;
        font-weight: 600;
    }

    .block .text{
        color: #ffffff;
        font-size: 16px;
        line-height: 1.55;
        font-weight: 400;
    }

    .block .text .msgtel{
        color: #ffffff;
        font-size: 20px;
        line-height: 1.55;
        font-weight: 400;
        text-decoration: none;
    }

    .block .text .email{
        color: #ffffff;
        line-height: 1.55;
        font-weight: 400;
    }


    .block .text .tel{
        color: #ffffff;
        font-size: 18px;
        line-height: 1.55;
        font-weight: 400;
        text-decoration: none;
    }


    .social{
        text-align: left;
    }

    .home-link{

    }

    .home-link img{
        width: 120px;
        height: 120px;
    }

    .social-links{
        display: flex;
        margin-top: 30px;
    }

    .t-sociallinks__item{
        margin-right: 4px;
    }

    .copy-right{
        margin-top: 21px;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 400;
        font-size: 14px;
        color: #525252;
        line-height: 1.55;
    }

    @media (max-width: 1211px){
        .block{
            width: 200px;
            height: 221px;
            margin: 0 20px;
            text-align: left;
            font-family: 'PT Sans',Arial,sans-serif;
        }
    }

    @media (max-width: 850px){
        footer{
            background-color: black;
            height: 900px;
            display: flex;
            flex-direction: column-reverse;
            justify-content: space-around;
            align-items: center;
        }

        .block{
            height: auto;
            width: 260px;
        }
    }

</style>